function find_current_variant() {
    default_variant = 0 == default_variant ? Object.keys(variants)[1] : default_variant, variant_id = $("select option[value='" + default_variant + "']").parent().val();
    var a, i = {};
    return $.each(document.location.search.substr(1).split("&"), function(a, t) {
        var e = t.split("=");
        try {
            i[e[0].toString()] = e[1].toString()
        } catch (a) {}
    }), isNaN(i.variant) ? a = variant_id || default_variant : freshLoad ? (freshLoad = !1, a = i.variant ? i.variant : variant_id || default_variant) : a = variant_id || default_variant, a ? (variant_id = a, a) : variant_id
}

function find_variant_images() {
    return variant_id = find_current_variant(), variant_images = variants[variant_id], "at_start" == general_images_position ? variant_images = variants.g.concat(variant_images) : "at_end" == general_images_position && (variant_images = variant_images.concat(variants.g)), variant_images
}
var freshLoad = !0,
    selected_theme_name = "MyShop",
    can_execute_script = !1,
    is_home = !1;
"/" == window.location.pathname && "Startup" == selected_theme_name ? (can_execute_script = !0, is_home = !0) : window.top.location.href.toLowerCase().indexOf("/products/") >= 0 ? can_execute_script = !0 : window.top.location.href.toLowerCase().indexOf("/products_preview?") >= 0 && (can_execute_script = !0), can_execute_script && 0 == $('[id*="multi-variant-"]').length && 0 == $("#multi-product-sliders").length && (variants = {}, product_images = [], default_variant = 0, general_images_position = "", is_home ? (product_url = $('[data-section-type="featured-product"] .product-title a').prop("href"), product_url = product_url.replace(/\/$/, "")) : product_url = "/products/" + window.top.location.href.split("/").slice(-1)[0].split("?")[0], $.getJSON(product_url + ".js", function(a) {
    $.each(a.variants, function(a, i) {
        if (!default_variant && i.available) return default_variant = i.id, !1
    }), $.getJSON(product_url + ".json", function(i) {
        function t() {
            /*$("#thumbnail-gallery .thumbnail-slider").bxSlider("destroy"), $(".bx-controls.bx-has-pager.bx-has-controls-direction").remove(),*/ variant_images = find_variant_images(), thumb_images = "", $.each(variant_images, function(a, i) {
                thumb_images += $("#multi-variant-info div[image_id='" + i.id + "']").clone().wrap("<div></div>").parent().html()
            }), $("#thumbnail-gallery").html("<div class='thumbnail-slider'></div>"), $("#thumbnail-gallery .thumbnail-slider").html(thumb_images), /*$("#thumbnail-gallery .thumbnail-slider").bxSlider({
                mode: "vertical",
                minSlides: 4,
                slideMargin: 10,
                infiniteLoop: !1,
                pager: !1,
                prevText: "",
                nextText: "",
                hideControlOnEnd: !0
            }),*/ $(".clicker-thumb").on("click", function(a) {
                a.stopPropagation(), a.preventDefault();
                var i = $(this).attr("href");
                return $("#product-main-image img").attr({
                    src: i
                }), !1
            })
        }
        a = i.product, product_images = a.images, variants.g = [], general_images = !0, current_variant_ids = [], product_images_without_general = [], all_variant_images = [], $.each(a.variants, function(a, i) {
            i.image_id && (all_variant_images[i.image_id] || (all_variant_images[i.image_id] = []), all_variant_images[i.image_id].push(i.id))
        }), $.each(a.images, function(a, i) {
            assign_variant_ids = all_variant_images[i.id], assign_variant_ids && (i.variant_ids.push.apply(i.variant_ids, assign_variant_ids), i.variant_ids = i.variant_ids.filter(function(a, i, t) {
                return t.indexOf(a) == i
            })), general_images && 0 == i.variant_ids.length ? variants.g.push(i) : (general_images = !1, current_variant_ids = i.variant_ids.length ? i.variant_ids : current_variant_ids, $.each(current_variant_ids, function(a, t) {
                variants[t] || (variants[t] = []), variants[t].push(i)
            }), product_images_without_general.push(i))
        }), $.each(a.variants, function(a, i) {
            i.image_id || (variants[i.id] = general_images_position ? product_images_without_general : product_images)
        }), $("#thumbnail-gallery div.slide").each(function(a, i) {
            $(i).attr("image_id", product_images[a].id)
        }), $("body").append("<div id='multi-variant-info' style='display:none'></div>"), $("#multi-variant-info").html($("#thumbnail-gallery").html()), t(), $("select").on("change", function() {
            setTimeout(function() {
                t()
            }, 100)
        })
    })
}));